export const environment = {
  production: false,
  basicAuth: false,
  isTesting: false,
  name: 'default',
  username: 'admin',
  password: '61n_Tes{k4uqI|=;2i',
  baseUrlLogin: '/api',
  baseUrl: '/api/v1',
  reportBaseUrl: '/api/v1',
  tilesBaseUrl: 'https://maps.skyforest.io',
  wsBaseUrl: 'ws://localhost:4200/ws/',
  defaultTeam: '',
  mapServerBaseUrl: 'https://maps.skyforest.io/',

  keycloak: {
    enabled: true,
    url: 'https://auth.skyforest.io',
    realm: 'skyforest',
    clientId: 'skyforest-api',
    clientSecret: 'oVdf4Uyadz5scypFITT6HxH7BNO8QNbi'
  }
};
